import { OdooModel } from './odoo-model.model';
import { OdooSerializableInterface } from '../shared/interfaces/odoo-serializable-interface';
import { SaleOrder } from './sale-order.model';
import { OdooMultiRelationship } from './odoo-multi-relationship.model';
import { StockMove } from './stock-move';
import { StockMoveLine } from './stock-move-line';
import { OdooRelationship } from './odoo-relationship.model';
import { StockPickingType } from './stock-picking-type.model';
import { ProcurementGroup } from './procurement.group.model';
import { Partner } from './partner';
import { StockLocation } from './stock-location';


export class StockPicking extends OdooModel implements OdooSerializableInterface<SaleOrder> {
  public readonly ODOO_MODEL = 'stock.picking';

  id: number;
  name:string = ""
  move_ids_without_package:OdooMultiRelationship<StockMove> = new OdooMultiRelationship<StockMove>(StockMove);
  move_lines:OdooMultiRelationship<StockMoveLine>;
  move_line_ids_without_package:OdooMultiRelationship<StockMoveLine> = new OdooMultiRelationship<StockMoveLine>(StockMoveLine);
  state: string = ""
  group_id:OdooRelationship<ProcurementGroup> = new OdooRelationship<ProcurementGroup>()
  picking_type_id:OdooRelationship<StockPickingType> = new OdooRelationship<StockPickingType>()
  origin:string = ""
  partner_id:OdooRelationship<Partner> = new OdooRelationship<Partner>()
  scheduled_date:string="";
  location_id: OdooRelationship<StockLocation> = new OdooRelationship<StockLocation>()
  location_dest_id: OdooRelationship<StockLocation> = new OdooRelationship<StockLocation>()
  
  constructor(id?: number, unit?: number, packages?: number, barcode?: string, state?:string) {
    super(id);
    this.id = id;
  }

  create(): StockPicking {
    return new StockPicking();
  }
}
